<h1 mat-dialog-title>{{"homeModule.refreshApp.refreshAppTitle" |translate}}</h1>
<div mat-dialog-content>
  {{"homeModule.refreshApp.refreshAppMessage" |translate}}
</div>

<div mat-dialog-actions>

  <button (click)="refresh()" mat-raised-button type="button" color="primary">
    <mat-icon>upgrade</mat-icon>
    {{"homeModule.refreshApp.update" |translate}}
  </button>
</div>
